<template>
    <div>
        <div :class="'challengePage anim'+ ( open ? ' open' : '' )">
            <div class="container h-100 animate__animated animate__fadeIn">
                <div v-if="data != null && open" class="row h-100">
                    <div class="col-md-6 h-100 m-auto">
                        <a @click.prevent="hide();btnSfx();" href="#" class="btnClose"></a>
                        <a @click.prevent="history(); btnSfx();" href="#" class="btnHistory animate__animated animate__bounceIn animate__delay-1s"></a>
                        <div class="top-gradient"></div>
                        <div class="typeList">
                            <div v-for="t in data" :key="t.id" :class="t.design">
                                <div v-if="t.design == 'green'" :class="t.activeChallenge != undefined || t.participationCount >= t.participationLimit ? 'bg dark' : 'bg'">
                                    <img src="/images/challenges/grass.png" class="grass1"/>
                                    <img src="/images/challenges/grass2.png" class="grass2"/>
                                    <div v-if="t.activeChallenge == undefined" class="hive-tree">
                                        <div class="hive-holder">
                                            <div class="hive">
                                                <div class="hendle"></div>
                                                <div class="honey" :style="'height:'+honeyPercent+'%;'"></div>
                                                <div class="hole"></div>
                                            </div>
                                        </div>
                                        <div class="percent">
                                            {{ honeyPercent > 0 ? honeyPercent+'%' : honeyResetDelay }}
                                            <span v-if="honeyPercent == 0">{{ $t("home.hive_tree_empty") }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div v-else-if="t.design == 'yellow'" :class="t.activeChallenge != undefined || t.participationCount >= t.participationLimit ? 'bg dark' : 'bg'">
                                    <div class="bear"></div>
                                    <img src="/images/challenges/honeycomb.png"/>
                                </div>
                                <div  v-else-if="t.design == 'purple'" :class="t.activeChallenge != undefined || t.participationCount >= t.participationLimit ? 'bg dark' : 'bg'">
                                    <img src="/images/challenges/cup.png"/>
                                    <img src="/images/challenges/type-high-tree.png"/>
                                </div>
                                <div  v-else-if="t.design == 'blue'" :class="t.activeChallenge != undefined || t.participationCount >= t.participationLimit ? 'bg dark' : 'bg'">
                                    <div class="bear"></div>
                                </div>
                                <a v-if="t.activeChallenge == undefined && t.participationCount < t.participationLimit" @click.prevent="play(t.id);btnSfx();" href="#" class="btn btn-lg btn-primary mb-3">
                                    <span v-if="t.stake > 0">{{ t.stake.abbr(true) }} <img src="/images/challenges/token-white.png"/></span>
                                    {{ $t('challenge.start_btn') }}
                                </a>
                                <div v-if="t.activeChallenge != undefined" class="wait">
                                    <img src="/images/challenges/dots.png"/>
                                    <div class="text-primary">{{ $t('challenge.type_wait_title') }}</div>
                                    <div class="score">
                                        <div>{{ $t('challenge.type_score_title') }}</div>
                                        <div v-if="t.activeChallenge.challenger.id == user.id ? t.activeChallenge.challengerAnswerCorrect : t.activeChallenge.challengeeAnswerCorrect" class="correct">
                                            <i class="fas fa-check-circle"></i> 
                                            {{ moment.utc(t.activeChallenge.challenger.id == user.id ? t.activeChallenge.challengerAnswerTime : t.activeChallenge.challengeeAnswerTime).format('s.SS') }}s
                                        </div>
                                        <div v-else class="incorrect"><i class="fas fa-times-circle"></i></div>
                                    </div>
                                </div>
                                <div v-else-if="t.participationCount >= t.participationLimit" class="limitRich text-center">
                                    <div><mark>{{ $t('challenge.type_limit_reach1') }}</mark></div>
                                    <div><mark>{{ $t('challenge.type_limit_reach2') }}</mark></div>
                                    <div>{{ $t('challenge.type_limit_reach3') }}</div>
                                </div>
                                <span v-if="t.profit > 0 && t.participationCount < t.participationLimit" class="award mb-3">{{ $t('challenge.type_profit_info') }} <b>{{ t.profit.abbr(true) }}</b> <img src="/images/token.png"></span>
                                <i>{{ t.participationCount }}/{{ t.participationLimit }}</i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <challenge-history ref="historyPopup" @reloadTypes="loadTypes"></challenge-history>
        <challenge-question ref="questionPopup" @reloadTypes="loadTypes"></challenge-question>
    </div>
</template>
<script>
import Vue from 'vue'
import app from '../app'
import api from '../api'
import ChallengeHistory from '../components/ChallengeHistory.vue';
import ChallengeQuestion from '../components/ChallengeQuestion.vue';

const Challenge = Vue.component('challenge', {
    components: {
        ChallengeHistory, ChallengeQuestion
    },

    honeyTimer: null,

    data() {
        return {
            open: false,
            data: null,
            challenge: null,
            honeyPercent: 100,
            honeyResetDelay: "00:00s",
            sortOrder: ['green', 'yellow','purple','blue']
        }
    },

    computed: {
        user() {
            return this.$store.state.auth.user;
        }
    },

    methods:{

        btnSfx(){
            this.$store.dispatch('sound/sfx','Button');
        },

        show() {
            const $this = this;
            let loader = document.getElementById('loader');
            loader.classList.add("show");
            $this.data = null;

            api.challengeTypes()
                .then(function (response) {
                    response.data.sort($this.typeSorter);
                    $this.data = response.data;
                    $this.open = true;
                    $this.$emit("hideBottomNav", true);
                    document.querySelectorAll(".user-resources .profile")[0].style.visibility = 'hidden';
                    $this.getBudget();
                })
                .catch(function (error) {
                    api.baseErrorHendler(error);
                })
                .then(function () {
                    loader.classList.remove("show");
                });
        },


        typeSorter(a, b){
            return this.sortOrder.indexOf(a.design) - this.sortOrder.indexOf(b.design);
        },


        showResults(id){
            const $this = this;
            let loader = document.getElementById('loader');
            loader.classList.add("show");

            api.challengeInfo(id)
                .then(function (response) {
                    $this.$refs.questionPopup.showResults(response.data);
                    $this.loadTypes();
                })
                .catch(function (error) {
                    api.baseErrorHendler(error);
                })
                .then(function () {
                    loader.classList.remove("show");
                });
        },

        loadTypes(){
            if(!this.open) return;
            this.show();
        },

        play(typeId) {
            const $this = this;
            let loader = document.getElementById('loader');
            loader.classList.add("show");

            api.applyToChallenge(typeId)
                .then(function (response) {
                    $this.$refs.questionPopup.show(response.data);
                })
                .catch(function (error) {
                    api.baseErrorHendler(error);
                })
                .then(function () {
                    loader.classList.remove("show");
                });
        },


        getBudget(){
            const $this = this;

            if(this.honeyTimer != null){
                clearInterval(this.honeyTimer);
                this.honeyTimer = null;
            }

            api.challengeBudget()
                .then(function (response) {
                    $this.honeyPercent = response.data.remainingPercentage;
                    if(response.data.resetDelay != undefined){
                        let endtime = moment.utc().add(moment.duration(response.data.resetDelay));
                        let startime = moment.utc();
                        $this.honeyResetDelay = $this.formatTime(endtime); 
                        $this.honeyTimer = setInterval(() => { 
                            if(!moment.utc().isAfter(endtime))
                                $this.honeyResetDelay = $this.formatTime(endtime);
                            else{
                                $this.getBudget(); 
                            } 
                        }, 1000);
                    }
                })
                .catch(function (error) {
                    api.baseErrorHendler(error);
                });
        },

        history(){
            this.$refs.historyPopup.show();
        },

        formatTime(time){
            let t = moment.duration(moment.utc(time).diff(moment.utc()));

            if(t.asDays() > 1)
                return t.days()+"d"+(t.hours() > 0 ? " "+ this.pad2(t.hours())+ "h" : "");
            else if(t.hours() > 0)
                return t.hours() + ":" + this.pad2(t.minutes())+"h";
            else if(t.minutes() > 0)
                return t.minutes() + ":" + this.pad2(t.seconds())+"m";

            return t.seconds()+"s";
        },

        pad2(number) {
            if(number < 0) number = 0;
            return (number < 10 ? '0' : '') + number
        },

        hide() {
            this.open = false;
            this.$emit("hideBottomNav", false);
            this.data = null;
            document.querySelectorAll(".user-resources .profile")[0].style.visibility = 'visible';

            if(this.honeyTimer != null){
                clearInterval(this.honeyTimer);
            }
        },  

    },

    beforeDestroy(){
        document.getElementById('loader').classList.remove("show");
    }
});

export default Challenge
</script>